const vapecraze = {
    id: 'vapecraze',
    publicSiteName: 'Vape Craze',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#ca181f',
            secondary: '#0e0e0e',
            color1: '#ed1b24',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapecraze/favicon.ico',
        logo: '/vapecraze/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
    pricing: {
        showVatBreakdown: false,
        vatDisplayFormat: 'both',
    },
}

export default vapecraze